<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>
    <div class="flex-grow">
      <main class="w-full">
        <CreateArticleComponent />
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/SidebarComponent.vue';
import CreateArticleComponent from '@/components/articles/CreateArticleComponent.vue';

export default {
  name: 'CreateArticle',
  components: {
    Sidebar,
    CreateArticleComponent
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style scoped>
/* keep styling consistent with other create views */
</style>
